import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { fetchDecaPdfBlob, formatApiErrorDetail } from "@/lib/api";
import { Loader2 } from "lucide-react";

export default function DecaPdfPage() {
  const { id } = useParams();
  const [src, setSrc] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let objectUrl;
    let cancelled = false;
    (async () => {
      try {
        const blob = await fetchDecaPdfBlob(id);
        if (cancelled) return;
        objectUrl = URL.createObjectURL(blob);
        setSrc(objectUrl);
      } catch (e) {
        if (!cancelled) {
          setError(formatApiErrorDetail(e.response?.data?.detail) || "No se pudo abrir el PDF");
        }
      }
    })();
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [id]);

  if (error) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-3 bg-slate-50 px-6 text-center">
        <p className="text-slate-800 font-medium">{error}</p>
        <Link to={`/decas/${id}`} className="text-blue-700 underline text-sm">Volver al DeCA</Link>
      </div>
    );
  }

  if (!src) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <Loader2 className="h-6 w-6 animate-spin text-slate-500" strokeWidth={1.5} />
      </div>
    );
  }

  return (
    <embed
      title={`DeCA ${id}`}
      src={src}
      type="application/pdf"
      className="w-screen h-screen border-0"
    />
  );
}
